import { hostBridge } from '@publicala/delfino';
import type { ContentStructure } from '@publicala/delfino';
import { DEFAULT_CONTENT_MOCK, isE2EMockActive } from '../e2eMockGuard';

/**
 * Content API for Volpe.
 * Provides methods to get content structure via hostBridge.
 */
class ContentAPI {
    /**
     * Get complete content structure.
     *
     * Returns a polymorphic structure based on fileType (pdf, epub, audio).
     * Returns mock data in E2E standalone mode.
     *
     * @returns Content structure
     */
    async getContentStructure(): Promise<ContentStructure> {
        if (isE2EMockActive()) {
            return DEFAULT_CONTENT_MOCK;
        }
        return hostBridge.content.getContentStructure();
    }
}

export const contentAPI = new ContentAPI();
